const modelName = 'Order Settings';
const modelNameSingular = 'Order Settings';
const endpoint = '/order-settings';

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: true,
  canAddNew: false,
  canSearch: true,
  endpoint,
  accessor: 'id',
};

export default setup;
